import { FunctionComponent, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { StoryCardPollContent } from '../../../../services';
import { HorizontalStoryFeedCardProps, HorizontalStoryFeedContentCommon } from '../../../../shared';
import { HorizontalStoryFeedCardWrapper } from '../HorizontalStoryFeedCardWrapper';

export const HorizontalStoryFeedPoll: FunctionComponent<HorizontalStoryFeedCardProps> = memo(
  ({ card }) => {
    const { t } = useTranslation();

    const { content, isPinnedToTopOfNewsFeed, isPinnedToTopOfStory } = card;

    const { headline, text } = content as StoryCardPollContent;

    return (
      <HorizontalStoryFeedCardWrapper card={card}>
        <HorizontalStoryFeedContentCommon
          isPinnedToTopOfNewsFeed={isPinnedToTopOfNewsFeed}
          isPinnedToTopOfStory={isPinnedToTopOfStory}
          source={t('common.vote-now')}
          title={headline}
          text={text}
        ></HorizontalStoryFeedContentCommon>
      </HorizontalStoryFeedCardWrapper>
    );
  }
);
